import { Box, Container, Link } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppRoute from 'router/AppRoute';
import { Link as ReactLink, useLocation } from 'react-router-dom';
import useAppTheme from 'hooks/shared/useAppTheme';

interface NavItem {
  href: string;
  title: string;
  isActive: boolean;
}

export const navbarHeight = 58;

const NavBar: FC = () => {
  const { t } = useTranslation();

  const location = useLocation();

  const navItems: NavItem[] = [
    {
      href: AppRoute.home,
      title: t('navMain'),
      isActive: new Set([AppRoute.home, AppRoute.generalSurvey]).has(location.pathname),
    },
    {
      href: AppRoute.strategies,
      title: t('navTrends'),
      isActive: location.pathname.startsWith(AppRoute.pe),
    },
    {
      href: AppRoute.portfolio,
      title: t('portfolio'),
      isActive: location.pathname.startsWith(AppRoute.portfolio),
    },
    {
      href: AppRoute.scor,
      title: t('navScor'),
      isActive: location.pathname.startsWith(AppRoute.scor),
    },
    {
      title: t('navCommunity'),
      href: AppRoute.eventsPath,
      isActive: location.pathname.includes(AppRoute.communityPath),
    },
     {
      title: t('aiChat'),
      href: AppRoute.aiPath,
      isActive: location.pathname.includes(AppRoute.aiPath),
    },
    {
      href: AppRoute.profile,
      title: t('navSettings'),
      isActive: location.pathname.startsWith(AppRoute.settings),
    },
  ];

  const theme = useAppTheme();

  return (
    <Box bgColor={Color.Surface} minW="980px">
      <Container display="flex" alignItems="center" height="58px">
        {navItems.map((nav, index) => (
          <Box
            key={index}
            h="100%"
            display="flex"
            alignItems="center"
            boxShadow={
              nav.isActive
                ? `inset 0px -6px 0px 0px ${theme.colors[Color.Primary500]}`
                : undefined
            }
            mr={index === navItems.length - 1 ? 0 : 42}
          >
            <Link as={ReactLink} to={nav.href} fontSize={FontSize.sm}>
              {nav.title}
            </Link>
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default NavBar;
